$(document).ready(function () {
    $("#table-sections-details").DataTable({
        "order": [[ 3, 'asc' ]],
        rowReorder: {
            selector: 'td:nth-child(2)'
        },
        responsive: true

    })

    $("#table-sections-details tbody").on('click','.show-pos-modal', function (e){
        e.preventDefault()
        $(".item-id").val($(this).data('section'))
        $(".item-order").val($(this).data('order'))
        $(".item-book").val($(this).data('book'))
        $(".item-book_title").text($(this).data('book_title'))
        $("#modal-position").modal('show')
    })

    $("#form-position-detail").on('submit',function (e){
        e.preventDefault()
        let data = new FormData(this)
        updatePosition(data)
    })

    function updatePosition(data) {
        $.ajax({
            method: "POST",
            url: "/admin/update-position-detail",
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: data,
            success: function (data) {
                console.log(data)
                if (data.type === "success") {
                    location.reload()
                }
            }
        });
    }
})
